import type { SurveyData } from "../../types";

export const handleCheckBoxChange = (
	id: string,
	name: keyof Pick<
		SurveyData,
		| "expertise"
		| "stockTypes"
		| "otherInvestments"
		| "goal"
		| "investorType"
		| "tools"
	>,
	setForm: React.Dispatch<React.SetStateAction<SurveyData>>,
) => {
	setForm((prev) => {
		const currentArray = [...(prev[name] || [])];
		const newArray = currentArray.includes(id)
			? currentArray.filter((item) => item !== id)
			: [...currentArray, id];

		return {
			...prev,
			[name]: newArray,
		};
	});
};
